export const CONTENT_TYPES = {
  APPLICATION_JSON: 'application/json'
};
